import { MediaFlexibleContentFragment } from "@graphqlTypes";
import { ImageGallery, VideoCarousel, VideoPlaylist } from "@components";

interface MapProps {
  content: MediaFlexibleContentFragment['mediaFlexibleContent'];
}

export default function ContentMap({ content }: MapProps) {
  return (
    <>
      {content?.map((component, index) => {
        // Add more cases for other component types as needed
        switch (component.__typename) {
          case "CeremonyLandingMediaFlexibleContentImageGalleryLayout":
            return <ImageGallery key={index} largeTitle={index === 0} {...component} />;
          case "CeremonyLandingMediaFlexibleContentVideoCarouselLayout":
            return <VideoCarousel key={index} largeTitle={index === 0} {...component} />;
          case "CeremonyLandingMediaFlexibleContentVideoPlaylistLayout":
            return <VideoPlaylist key={index} largeTitle={index === 0} {...component} />;
          default:
            // @ts-ignore Handle unknown component types gracefully
            console.warn(`MEDIA FLEXIBLE CONTENT: No component found for type: ${component.__typename}`);
            return null;
        }
      })}
    </>
  );
}
